<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="part-i-the-shape-of-things-familiar">
<h1 style="padding: 250px  0 0 0;">Part I<br/> The Shape of Things Familiar</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?ef4aa010